// Temporary email gate for the Airbnb onboarding page. Today only
// help@curatedplanet.com (internal staff) may use it; when self-serve lands,
// swap this for a real permission check (and the backend gate in
// demo.lib.airbnb_oauth.user_can_manage_airbnb in lockstep).
export const AIRBNB_UI_ALLOWED_EMAILS = ['help@curatedplanet.com'];

function getBootstrapUserEmail() {
    try {
        const raw = window.localStorage.getItem('bootstrap');
        if (!raw) return null;
        const email = JSON.parse(raw)?.user?.email;
        return typeof email === 'string' ? email.trim().toLowerCase() : null;
    } catch {
        return null;
    }
}

export function userCanAccessAirbnbUi() {
    const email = getBootstrapUserEmail();
    return !!email && AIRBNB_UI_ALLOWED_EMAILS.map((e) => e.toLowerCase()).includes(email);
}
